<template>
  <div class="editor-subject w-100">
    <div class="d-flex align-items-center">
      <vue-editor
        id="EditorSubject"
        :ref="uniqref"
        v-model="content"
        class="w-100 overflow-auto m-0"
        :editor-options="editorSettings"
        @selection-change="selectionChange"
        @focus="onFocus"
        @blur="onBlur"
      />
    </div>
    <div
      v-show="active"
      id="EditorSubjectCustomToolbar"
    >
      <button class="ql-addTag" />
    </div>
  </div>
</template>
<script>
import { VueEditor, Quill } from 'vue2-editor';
import $ from 'jquery';
import QuillHashtag from '../../_utilities/QuillHashtag';

import VueEditorMixins from '../../_utilities/VueEditorMixins';

export default {
  name: 'EditorSubject',
  components: {
    VueEditor,
  },
  mixins: [VueEditorMixins],
  data() {
    return {
      active: false,
      content: '',
      editorSettings: {
        formats: [
          'hashtag',
        ],
        modules: {
          toolbar: {
            container: '#EditorSubjectCustomToolbar',
            handlers: {
              addTag: () => {
                this.addCustomTag('Name');
              },
            },
          },
        },
      },
    };
  },
  watch: {
    content() {
      const dom = $(this.content);
      dom.find('.quill-hashtag').replaceWith(
        '<span class="quill-hashtag">Name</span>',
      );
      let lines = '';
      Object.keys(dom).forEach((d) => {
        lines += dom[d].outerHTML;
      });
      this.$emit('input', lines.replace('<p><br></p>', ''));
    },
    value() {
      this.content = this.value;
    },
  },
  mounted() {
    Quill.register(QuillHashtag);

    // Removes the Enter key event
    this.$refs[this.uniqref].quill.keyboard.bindings[13].unshift({
      key: 13,
      handler: (range, context) => false,
    });
  },
  methods: {
    onFocus() {
      this.active = true;
    },
    onBlur() {
      this.active = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.editor-subject{
    position: relative;
}
#EditorSubjectCustomToolbar{
    position: absolute;
    right: 0;
    top: 0;
    background-color: transparent !important;
}
</style>
<style lang="scss">
#EditorSubject{
    box-shadow: none;
    height: 48px;
}
#EditorSubject .ql-editor{
    max-height: 48px;
    min-height: 48px;
    max-width: 740px;
    white-space: pre-wrap;
    font-family: 'SilkaLight';
    font-size: 14px;
    padding-right: unset !important;
}
#EditorSubject .ql-editor p{
    padding-bottom: 6px;
    height: 24px !important;
    display: block;

}
#EditorSubject .ql-editor br{
    display: none;
}
#EditorSubjectCustomToolbar.ql-toolbar{
    border: none !important;
    position: absolute;
    transform: none;
    bottom: unset;
    width: unset;
}

</style>
